
const digest = '001a69c4555894f99dc8d114923b09e01d7fcc3f54c3b885729eb8d29fb2ea5a';
const classes = {"wrapper":"_wrapper_1fker_1","controls":"_controls_1fker_7","list":"_list_1fker_14","content":"_content_1fker_23"};
const css = `._wrapper_1fker_1 {
  font-family: Rubik, "sans-serif";
  display: flex;
  flex-direction: column;
  height: 100%;
}
._wrapper_1fker_1 ._controls_1fker_7 {
  padding: 12px 12px;
  width: 100%;
  border-left: 1px solid #eaedf3;
  border-right: 1px solid #eaedf3;
  background: #ffffff;
}
._wrapper_1fker_1 ._list_1fker_14 {
  flex: 1;
  background: #ffffff;
  height: 100%;
  border: 1px solid #eaedf3;
  display: flex;
  flex-direction: column;
  box-shadow: inset 0 4px 0 0 rgba(226, 229, 237, 0.3);
}
._wrapper_1fker_1 ._content_1fker_23 {
  flex: 1;
  background: #ffffff;
  border: 1px solid #eaedf3;
  padding: 12px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  